import { type SerializedPageStructure } from '@wix/document-services-types'
import { BUTTON_ROLE } from '@wix/wix-data-client-common-standalone'
import { type Schema } from '@wix/wix-data-schema-types'

import {
  assertNonNullable,
  getComponentByVeloId,
  getItemPageFieldKey,
  modifyComponentByVeloId,
  modifyConnectionConfigOfComponentAndControllerWithVeloIds,
  normalizeLastItemMarginInStack,
  setConnectionConfigPropertyField,
} from './utils'
import { ROUTER_DATASET_VELO_ID } from './veloIds'

const VIEW_ITEM_ACTION_VELO_ID = 'viewItemAction'

export const rebindOrRemoveViewItemAction = ({
  page,
  fields,
  displayFieldKey,
}: {
  page: SerializedPageStructure
  fields: Schema['fields']
  displayFieldKey: string
}): SerializedPageStructure => {
  const itemPageFieldKey = getItemPageFieldKey({ fields, displayFieldKey })
  return itemPageFieldKey !== null
    ? modifyConnectionConfigOfComponentAndControllerWithVeloIds({
        page,
        componentVeloId: VIEW_ITEM_ACTION_VELO_ID,
        controllerVeloId: ROUTER_DATASET_VELO_ID,
        role: BUTTON_ROLE,
        modifyConnectionConfig: config =>
          setConnectionConfigPropertyField({
            config,
            propertyName: 'link',
            fieldKey: itemPageFieldKey,
          }),
      })
    : modifyComponentByVeloId({
        root: page,
        veloId: 'itemActionStack',
        modifyComponent: actionStack => {
          assertNonNullable(actionStack.components)
          const viewAction = getComponentByVeloId({
            root: actionStack,
            veloId: VIEW_ITEM_ACTION_VELO_ID,
          })
          const viewActionIndex = actionStack.components.indexOf(viewAction)
          if (viewActionIndex === -1) {
            throw new Error(
              'The view-item action is not a direct child of the action stack.',
            )
          }
          const viewActionIsLast =
            viewActionIndex === actionStack.components.length - 1
          const actionStackWithoutViewAction: typeof actionStack = {
            ...actionStack,
            components: [
              ...actionStack.components.slice(0, viewActionIndex),
              ...(viewActionIsLast
                ? []
                : actionStack.components.slice(viewActionIndex + 1)),
            ],
          }
          return viewActionIsLast
            ? normalizeLastItemMarginInStack(actionStackWithoutViewAction)
            : actionStackWithoutViewAction
        },
      })
}
